import { CheckoutAddress } from './checkout-address.interface';
import { CheckoutPurchase } from './checkout-purchase.interface';

export interface CheckoutItemDetails {
  address: CheckoutAddress[];
  itemTypeCode: string;
  manufacturerBrandCode: string;
  modelNumber: string;
  operationalStatusCode: string;
  purchase: CheckoutPurchase;
  serialNumber: string;
}
